'use strict';

export const CREATE_ASSET_NAME = 'createAsset';
export const CREATE_ASSET_PREFIX = `@@${CREATE_ASSET_NAME}`;

export const DELETE_ASSET_NAME = 'deleteAsset';
export const DELETE_ASSET_PREFIX = `@@${DELETE_ASSET_NAME}`;

export const UPDATE_ASSET_NAME = 'updateAsset';
export const UPDATE_ASSET_PREFIX = `@@${UPDATE_ASSET_NAME}`;

export const ASSETS_PROJECTS_LIST_NAME = 'assetsProjectsList';
export const ASSETS_PROJECTS_LIST_PREFIX = `@@${ASSETS_PROJECTS_LIST_NAME}`;



// WEBPACK FOOTER //
// ./src/js/assets/redux/state.js